import { render, staticRenderFns } from "./CarouselSideCard.vue?vue&type=template&id=706b7776&scoped=true&"
import script from "./CarouselSideCard.vue?vue&type=script&lang=js&"
export * from "./CarouselSideCard.vue?vue&type=script&lang=js&"
import style0 from "./CarouselSideCard.vue?vue&type=style&index=0&id=706b7776&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706b7776",
  null
  
)

export default component.exports